// /legal: Terms and Privacy as two tabs, #terms and #privacy (W4-5; D-19),
// inside the site frame (routes/_site.tsx). Privacy is the holding notice
// (OD-B3) until the reviewed statement is approved.
import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '@/features/site/legal/LegalPage';

export const Route = createFileRoute('/_site/legal')({
  component: LegalPage,
});
